/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { AWSCategoryMetaTable } from "./AWSCategoryMetaTable";
import { AWSFieldMetaTable } from "./AWSFieldMetaTable";
import { AWSMetaTable } from "./AWSMetaTable";
import { AWSTagMetaTable } from "./AWSTagMetaTable";
import { AzureCategoryMetaTable } from "./AzureCategoryMetaTable";
import { AzureFieldMetaTable } from "./AzureFieldMetaTable";
import { AzureMetaTable } from "./AzureMetaTable";
import { AzureTagMetaTable } from "./AzureTagMetaTable";
import { EnvService } from "namirasoft-core";
import { GCPCategoryMetaTable } from "./GCPCategoryMetaTable";
import { GCPFieldMetaTable } from "./GCPFieldMetaTable";
import { GCPMetaTable } from "./GCPMetaTable";
import { GCPTagMetaTable } from "./GCPTagMetaTable";
import { NSBaseMetaDatabase } from "namirasoft-site";
import { NamirasoftBillWatchServer } from "../NamirasoftBillWatchServer";
import { RuleCategoryMetaTable } from "./RuleCategoryMetaTable";
import { RuleFieldMetaTable } from "./RuleFieldMetaTable";
import { RuleMetaTable } from "./RuleMetaTable";
import { RuleTagMetaTable } from "./RuleTagMetaTable";
import { TokenManager } from "namirasoft-account";

export class NamirasoftBillWatchMetaDatabase extends NSBaseMetaDatabase<NamirasoftBillWatchServer>
{
    private manager?: TokenManager;
    private onError?: (error: Error) => void;
    public override tables: {
        aws_category: AWSCategoryMetaTable,
        aws_field: AWSFieldMetaTable,
        aws_tag: AWSTagMetaTable,
        aws: AWSMetaTable,
        azure_category: AzureCategoryMetaTable,
        azure_field: AzureFieldMetaTable,
        azure_tag: AzureTagMetaTable,
        azure: AzureMetaTable,
        gcp_category: GCPCategoryMetaTable,
        gcp_field: GCPFieldMetaTable,
        gcp_tag: GCPTagMetaTable,
        gcp: GCPMetaTable,
        rule_category: RuleCategoryMetaTable,
        rule_field: RuleFieldMetaTable,
        rule_tag: RuleTagMetaTable,
        rule: RuleMetaTable,
    };
    constructor(manager?: TokenManager, onError?: (error: Error) => void)
    {
        super({ id: "prd-237ccb143fb04e52", name: "Namirasoft Bill Watch", headline: "Take Control of Your Bills", description: "Bill Watch monitors your costs, detects unusual charges, and alerts you to keep you in control and avoid unexpected costs.", logo: "https://static.namirasoft.com/image/namirasoft/bill-watch/logo/base/2048.png", link: "https://bill-watch.namirasoft.com" });
        this.manager = manager;
        this.onError = onError;
        this.tables = {
            aws_category: new AWSCategoryMetaTable(this),
            aws_field: new AWSFieldMetaTable(this),
            aws_tag: new AWSTagMetaTable(this),
            aws: new AWSMetaTable(this),
            azure_category: new AzureCategoryMetaTable(this),
            azure_field: new AzureFieldMetaTable(this),
            azure_tag: new AzureTagMetaTable(this),
            azure: new AzureMetaTable(this),
            gcp_category: new GCPCategoryMetaTable(this),
            gcp_field: new GCPFieldMetaTable(this),
            gcp_tag: new GCPTagMetaTable(this),
            gcp: new GCPMetaTable(this),
            rule_category: new RuleCategoryMetaTable(this),
            rule_field: new RuleFieldMetaTable(this),
            rule_tag: new RuleTagMetaTable(this),
            rule: new RuleMetaTable(this),
        };
    }
    override getServer(): NamirasoftBillWatchServer
    {
        if (!this.manager || !this.onError)
            throw new Error("Arguments of NamirasoftBillWatchMetaDatabase (manager, onError) are required for server operations.")
        let NAME = NSBaseMetaDatabase.getServerBaseURL(this.product.name);
        let BASE_URL = new EnvService(NAME, true).getString();
        return new NamirasoftBillWatchServer(BASE_URL, this.manager, this.onError);
    }
};